import { UsageGridBase } from './UsageGridBase.js';
import type { TaskUsageProps } from './types.js';

/**
 * 任務使用狀況：任務 → 其下的指派資源，右側逐時段格線（日／週／月）。
 * 與 ResourceUsage 結構對稱，純展示元件。
 */
export function TaskUsage(props: TaskUsageProps): React.JSX.Element {
  return <UsageGridBase {...props} testIdPrefix="task-usage" groupLabelHeader="任務" />;
}

export default TaskUsage;
